(() => {
  if (typeof window.customElements.get('tabbed-carousel') !== 'undefined') { return }

  window.customElements.define('tabbed-carousel', class TabbedCarousel extends HTMLElement { // eslint-disable-line
    constructor () {
      super()

      this.tabs = this.querySelectorAll('.tabbed-carousel__tab')
      this.bullets = this.querySelectorAll('.tabbed-carousel__bullet')
      this.panels = this.querySelectorAll('[data-tab-panel]')
      this.swipers = new Map()

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.getAttribute('data-tab-target')))
      })
      this.bullets.forEach((bullet) => {
        bullet.addEventListener('click', () => this.selectTab(bullet.getAttribute('data-tab-target')))
      })

      const activePanel = this.querySelector('[data-tab-panel].is-active')
      if (activePanel) { this.initSwiper(activePanel) }

      // Compact panel on mobile (opt-in section setting). Nothing below runs
      // for sections without it.
      if (this.classList.contains('tabbed-carousel--mobile-compact')) { this.initCompact() }
    }

    initCompact () {
      this.compactQuery = window.matchMedia('(max-width: 989px)')

      this.addEventListener('click', (event) => {
        const nextButton = event.target.closest('[data-tc-next]')
        if (nextButton && this.contains(nextButton)) {
          this.goToNextTab(nextButton)
          return
        }

        const moreButton = event.target.closest('[data-tc-more]')
        if (moreButton && this.contains(moreButton)) {
          this.toggleDescription(moreButton)
          return
        }

        // A tab was switched (by the existing tab handler): the newly shown
        // panel can now be measured.
        if (event.target.closest('[data-tab-target]')) {
          window.requestAnimationFrame(() => this.syncMoreButtons())
        }
      })

      let resizeTimer
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer)
        resizeTimer = window.setTimeout(() => this.syncMoreButtons(), 150)
      })

      window.requestAnimationFrame(() => this.syncMoreButtons())
    }

    goToNextTab (nextButton) {
      const targetId = nextButton.getAttribute('data-tc-next')
      const tab = Array.from(this.tabs).find((t) => t.getAttribute('data-tab-target') === targetId)
      if (!tab) { return }

      this.selectTab(targetId)
      window.requestAnimationFrame(() => this.syncMoreButtons())

      // Bring the tab row back into view (below a sticky header, if any)
      // so the shopper starts the new tab at its title.
      const tabRow = this.querySelector('.tabbed-carousel__tabs')
      if (tabRow) {
        const top = tabRow.getBoundingClientRect().top
        const offset = this.stickyHeaderHeight() + 12
        if (top < offset) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          window.scrollTo({ top: window.scrollY + top - offset, behavior: reduceMotion ? 'auto' : 'smooth' })
        }
      }

      tab.focus({ preventScroll: true })
    }

    stickyHeaderHeight () {
      let height = 0
      document.querySelectorAll('.shopify-section-group-header-group, .site-header').forEach((el) => {
        const position = window.getComputedStyle(el).position
        if (position !== 'sticky' && position !== 'fixed') { return }
        const rect = el.getBoundingClientRect()
        if (rect.top <= 1 && rect.bottom > height) { height = rect.bottom }
      })
      return height
    }

    toggleDescription (moreButton) {
      const description = document.getElementById(moreButton.getAttribute('aria-controls'))
      if (!description) { return }

      const expanded = description.classList.toggle('is-expanded')
      moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false')
      moreButton.textContent = expanded ? 'less' : 'more'
    }

    // Show "more" only when the two-line clamp actually hides text.
    syncMoreButtons () {
      this.querySelectorAll('[data-tc-more]').forEach((moreButton) => {
        const description = document.getElementById(moreButton.getAttribute('aria-controls'))
        if (!description) { return }

        if (!this.compactQuery.matches) {
          moreButton.hidden = true
          return
        }
        if (description.classList.contains('is-expanded')) {
          moreButton.hidden = false
          return
        }
        if (description.offsetParent === null) { return } // panel hidden: measured when shown

        moreButton.hidden = description.scrollHeight <= description.clientHeight + 1
      })
    }

    selectTab (targetId) {
      this.tabs.forEach((t) => {
        const active = t.getAttribute('data-tab-target') === targetId
        t.classList.toggle('is-active', active)
        t.setAttribute('aria-selected', active ? 'true' : 'false')
      })

      this.bullets.forEach((b) => {
        const active = b.getAttribute('data-tab-target') === targetId
        b.classList.toggle('is-active', active)
        b.setAttribute('aria-current', active ? 'true' : 'false')
      })

      this.panels.forEach((panel) => {
        const active = panel.getAttribute('data-tab-panel') === targetId
        panel.classList.toggle('is-active', active)

        if (active) {
          panel.removeAttribute('hidden')
          // Swiper can't measure slides while a panel is hidden, so the
          // slider for a panel is only built the first time it's shown.
          this.initSwiper(panel)
        } else {
          panel.setAttribute('hidden', '')
        }
      })
    }

    initSwiper (panel) {
      const existing = this.swipers.get(panel)
      if (existing) {
        existing.update()
        return
      }

      const slider = panel.querySelector('[data-swiper-slider]')
      if (!slider) { return }

      const swiper = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        threshold: 10,
        watchOverflow: true,
        navigation: {
          nextEl: panel.querySelector('[data-swiper-next]'),
          prevEl: panel.querySelector('[data-swiper-prev]')
        },
        breakpoints: {
          760: { spaceBetween: 20 },
          1025: { spaceBetween: 24 }
        }
      })

      this.swipers.set(panel, swiper)
    }
  })
})()
